<template>
  <b-container fluid>
    <page-title><h2><router-link :to="{ name: 'InvoicePaymentTypeList' }" class="nav-link">Typy płatności</router-link>/Nowy typ płatności</h2></page-title>

    <div class="col page-element">
      <alert-loading v-if="loading"></alert-loading>
      <div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>

      <InvoicePaymentTypeForm v-if="!loading" :handle-submit="create" :values="item" :errors="violations"></InvoicePaymentTypeForm>
    </div>
  </b-container>
</template>

<script>
  import InvoicePaymentTypeForm from './Form.vue';
  import { createNamespacedHelpers } from 'vuex';

  const { mapActions, mapGetters } = createNamespacedHelpers('invoicepaymenttype/create');

  export default {
    components: {
      InvoicePaymentTypeForm
    },
    created(){
      this.$store.dispatch('invoicepaymenttype/create/reset');
    },
    data: function() {
      return {
        item: {}
      }
    },
    computed: mapGetters([
      'error',
      'loading',
      'created',
      'violations'
    ]),
    methods: {
      create: function(item) {
        this.$store.dispatch('invoicepaymenttype/create/create', item);
      }
    },
    watch: {
      created: function (created) {
        if (created) {
          this.$router.push({ name: 'InvoicePaymentTypeUpdate', params: { id: created['id']} });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Create.vue?4c44b611